import _ from 'lodash';
import React from 'react';
import { browserHistory } from 'react-router'
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const BASE_URL = '/infographics/elections';

const OPTIONS = [
  { value: 'presidential-candidates', label: 'Presidential Candidates' },
  { value: 'gun-control', label: 'Gun Control' },
  { value: 'immigration-policy', label: 'Immigration Policy' },
  { value: 'tax-policy', label: 'Tax Policy' }
];

const Elections = React.createClass({
  displayName: 'Elections',
  propTypes: {
    label: React.PropTypes.string,
    searchable: React.PropTypes.bool,
  },
  getDefaultProps () {
    return {
      label: 'Select results for:',
      searchable: false,
    };
  },
  getInitialState () {
    return {
      disabled: false,
      searchable: this.props.searchable,
      selectValue: window.location.pathname.split('/')[3],
      clearable: false,
    };
  },
  _getParams() {
    const array = window.location.pathname.split('/');
    _.pullAt(array, [1, 2, 3]) // removes first two values

    return array.join('/');
  },
  updateValue (newPath) {
    const params = this._getParams();
    browserHistory.push(`${BASE_URL}/${newPath}${params}`);
    this.setState({ selectValue: newPath });
  },
  render () {
    return (
      <div className="section">
        <h3 className="section-heading">{this.props.label}</h3>
        <div className="select-container">
          <Select
            autofocus
            options={OPTIONS}
            simpleValue
            clearable={this.state.clearable}
            name="selected-state"
            disabled={this.state.disabled}
            value={this.state.selectValue}
            onChange={this.updateValue}
            searchable={this.state.searchable} />
        </div>
      </div>
    );
  }
});

export default Elections;



/** WEBPACK FOOTER **
 ** ./src/components/dataset_selector/index.js
 **/